"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NativeToolbarButton", {
    enumerable: true,
    get: function() {
        return NativeToolbarButton;
    }
});
const NativeToolbarButton = ()=>null;

//# sourceMappingURL=native.js.map
